import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { MemberAPI } from "../../../axios/api";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";
import moment from "moment";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import {
  FormInputtext,
  FormInputnumber,
  FormInputpassword,
  FormRadio,
  FormCheckbox,
  FormCalendar,
} from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";
import { option_enabled } from "../../../service/option";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackMemberProfile() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "會員資料管理",
      command: () => route_navigate("/back/member"),
    },
    {
      key: 2,
      label: "編輯",
    },
  ];
  const [reload, setReload] = useState({
    list: true,
  });
  const disabled = false;
  // 明細資料
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    username: "",
    password: "",
    name: "",
    sex: null,
    age: null,
    birthday: null,
    height: null,
    is_job: null,
    cel: "",
    is_fhofpchd: null,
    type: 1,
    enabled: 1,
  };
  const {
    handleSubmit,
    reset,
    setValue,
    trigger,
    watch,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  // 監聽欄位
  const watchColumn = {
    password: watch("password"),
    repassword: watch("repassword"),
    birthday: watch("birthday"),
  };

  useEffect(() => {
    setSchema(
      yup
        .object({
          username: yup.string().required("必填"),
          password: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return route_params.detailid === "add" || data.repassword
                  ? value && value === data.repassword
                  : true;
              }
            )
            .nullable(),
          repassword: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return route_params.detailid === "add" || data.password
                  ? value && value === data.password
                  : true;
              }
            )
            .nullable(),
          name: yup.string().required("必填"),
          sex: yup.number().required("必填"),
          birthday: yup.string().required("必填").nullable(),
          height: yup.number().required("必填"),
          is_job: yup.number().required("必填"),
          cel: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  // 動態判斷欄位
  useEffect(() => {
    if (setting.isSubmitted) trigger(["password", "repassword"]);
  }, [watchColumn.password, watchColumn.repassword]);
  useEffect(() => {
    // 計算年齡
    let age = null;
    if (watchColumn.birthday) {
      age = moment().diff(watchColumn.birthday, "years");
    }
    setValue("age", age);
    trigger("age");
  }, [watchColumn.birthday]);

  useAbortedEffect(
    (signal) => {
      if (!reload.list || route_params.detailid === "add") {
        return;
      }

      dispatch(setProgress(true));

      let params = { id: route_params.detailid };

      MemberAPI.getUserListDeatils({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          console.log(data);
          let temp = formatResData(defaultValues, data);
          setApiData(temp);
          reset(temp);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      ...submitData,
      birthday: moment(submitData.birthday).format("YYYY-MM-DD"),
    };

    if (!checkFormUpdate(jsonData, apiData)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      route_navigate("/back/member");
      return;
    }

    if (!submitData.repassword) {
      delete jsonData.password;
    }
    delete jsonData.repassword;

    console.log(jsonData);

    let promise,
      toast = "";
    if (route_params.detailid === "add") {
      // 新增
      promise = MemberAPI.setAccountData({
        data: jsonData,
      });
      toast = "新增";
    } else {
      // 修改
      delete jsonData.username;
      jsonData.id = Number(route_params.detailid);
      promise = MemberAPI.updateAccountData({
        data: jsonData,
      });
      toast = "編輯";
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        route_navigate("/back/member");
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">會員資料管理 - 編輯</h2>

      <div className="border-round-lg bg-white mt-3 p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="username"
              className={classNames(
                { "p-error": errors.username },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              帳號
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "username",
                  disabled: route_params.detailid !== "add",
                }}
              />
            </div>
          </div>

          {!disabled && (
            <>
              <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
                <label
                  htmlFor="password"
                  className={classNames(
                    { "p-error": errors.password },
                    "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
                  )}
                >
                  {route_params.detailid === "add" && (
                    <span className="text-red-400 mr-1">*</span>
                  )}
                  密碼
                </label>
                <div className="col-12 sm:col-10 lg:col-5 md:col-8">
                  <FormInputpassword
                    setting={setting}
                    data={{
                      name: "password",
                    }}
                  />
                </div>
              </div>

              <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
                <label
                  htmlFor="repassword"
                  className={classNames(
                    { "p-error": errors.repassword },
                    "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
                  )}
                >
                  {route_params.detailid === "add" && (
                    <span className="text-red-400 mr-1">*</span>
                  )}
                  確認密碼
                </label>
                <div className="col-12 sm:col-10 lg:col-5 md:col-8">
                  <FormInputpassword
                    setting={setting}
                    data={{ name: "repassword" }}
                  />
                </div>
              </div>
            </>
          )}

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="name"
              className={classNames(
                { "p-error": errors.name },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              姓名
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "name",
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="sex"
              className={classNames(
                { "p-error": errors.sex },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              性別
            </label>
            <div className="flex flex-wrap col-12 sm:col-10 lg:col-5 md:col-8">
              <FormRadio
                setting={setting}
                data={{
                  name: "sex",
                  label: "男",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "sex",
                  label: "女",
                  value: 2,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="birthday"
              className={classNames(
                { "p-error": errors.birthday },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              生日
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormCalendar
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "birthday",
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="age"
              className={classNames(
                { "p-error": errors.age },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              年齡
            </label>
            <div className="flex col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputnumber
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "age",
                  disabled: true,
                }}
              />
              <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
                歲
              </div>
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="height"
              className={classNames(
                { "p-error": errors.height },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              身高
            </label>
            <div className="flex col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputnumber
                className="w-full -mr-1px"
                setting={setting}
                data={{
                  name: "height",
                }}
              />
              <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
                公分
              </div>
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="is_job"
              className={classNames(
                { "p-error": errors.is_job },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              工作
            </label>
            <div className="flex flex-wrap col-12 sm:col-10 lg:col-5 md:col-8 pl-1">
              <FormRadio
                setting={setting}
                data={{
                  name: "is_job",
                  label: "是",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "is_job",
                  label: "否",
                  value: 2,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="cel"
              className={classNames(
                { "p-error": errors.cel },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              手機
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "cel",
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="is_fhofpchd"
              className={classNames(
                { "p-error": errors.is_fhofpchd },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              早發冠心病家族史
            </label>
            <div className="flex flex-wrap col-12 sm:col-10 lg:col-5 md:col-8 pl-1">
              <FormRadio
                setting={setting}
                data={{
                  name: "is_fhofpchd",
                  label: "是",
                  value: 1,
                }}
              />
              <FormRadio
                setting={setting}
                data={{
                  name: "is_fhofpchd",
                  label: "否",
                  value: 0,
                }}
              />
            </div>
          </div>

          <div className="field col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => route_navigate("/back/member")}
            />
            {!disabled && (
              <Button type="submit" label="儲存" className="ml-2 px-3" />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
